<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="zone flex flex-center">
      <div class="zone-inner">
        <div class="zone-path">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'allianceList' }"
              >联盟专区</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="flex flex-row">
          <DetailBrief :data="detail" class="flex-1" /><!-- 联盟信息简介-->
          <el-carousel height="233px" v-if="banners.length" class="zone-banner">
            <template v-for="(item, index) in banners">
              <el-carousel-item :key="index" v-if="index < 6">
                <img :src="item.carouselUrl" class="zone-bannerImg" />
              </el-carousel-item>
            </template>
          </el-carousel>
        </div>
        <Notice :data="detail.leagueNotices" />
        <DetailTabs :data="detail" /><!-- 联盟信息-->
        <Activities /><!-- 联盟活动-->
        <!-- 联盟专家-->
        <!-- <Specialist /> -->
        <Members /><!-- 联盟成员-->
        <Download /><!-- 联盟资料下载-->
      </div>
    </div>
    <FootBar />
  </div>
</template>
<script>
import { allianceDetail, allianceBanner } from "@/api/allianceZone";
import DetailBrief from "./components/DetailBrief";
import DetailTabs from "./components/DetailTabs";
import Activities from "./components/Activities";
// import Specialist from "./components/Specialist";
import Members from "./components/Members";
import Download from "./components/Download";
import Notice from "./components/Notice";
export default {
  components: {
    DetailBrief,
    DetailTabs,
    Activities,
    // Specialist,
    Members,
    Download,
    Notice,
  },
  data() {
    return {
      detail: {},
      leagueId: null,
      banners: [],
    };
  },
  created() {
    this.leagueId = this.$route.query.id;
    this.getAllianceDetail();
    this.getBanner();
  },
  methods: {
    async getBanner() {
      const data = await this.$axios.post(allianceBanner, {
        leagueId: this.leagueId,
      });
      this.banners = data || [];
    },
    async getAllianceDetail() {
      const data = await this.$axios.get(allianceDetail, {
        leagueId: this.leagueId,
      });
      this.detail = data;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.zone {
  background: $home-bg;
  padding-top: 20px;
  &-inner {
    width: $max-width;
    min-height: 500px;
  }
  &-path {
    margin-bottom: 20px;
  }
  &-banner {
    width: 300px;
    margin-left: 15px;
    ::v-deep .el-carousel__button {
      width: 3px;
    }
  }
  &-bannerImg {
    width: 300px;
    height: 233px;
    object-fit: cover;
  }
}
</style>
